import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, Row } from "antd";
import styles from "./Signup.module.css";
import authImg from "../../../assets/authImg.png";
import {
  Box,
  DropDown,
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import google from "../../../assets/google.png";
import facebook from "../../../assets/facebook.png";
import companyImg from "../../../assets/companyImg.png";
import { useLocation, useNavigate } from "react-router-dom";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import moment from "moment";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
const Signup = () => {
  // const Theme = useSelector(state => state.ThemeReducer.Theme);
  // const Types = useSelector(state => state.GeneralReducer.GeneralTypes);
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [passwordVisible, setpasswordVisible] = useState(true);
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [DOB, setDOB] = useState(null);
  const [phonenumber, setphonenumber] = useState("");
  const [SelectedVendorType, setSelectedVendorType] = useState("");
  const [CompanyName, setCompanyName] = useState("");
  const [CompanyImage, setCompanyImage] = useState(null);
  const [Service, setService] = useState([]);
  const [Experience, setExperience] = useState("");
  const [confPasswordVisible, setconfPasswordVisible] = useState(true);
  const [services, setServices] = useState("");
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const { state } = useLocation();
  const userRole = state?.role;
  console.log("userrRole", userRole);

  const hiddenFileInput = React.useRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleChangeVendorType = (value) => {
    setSelectedVendorType(value);
  };

  const handleChangeService = (value) => {
    setServices(value);
  };

  useEffect(() => {
    dispatch(AuthMiddleware.GeneralType()).then((data) => {
      setService(data?.servicecategory);
    });
  }, []);

  const onSignUp = () => {
    if (
      !firstName ||
      !lastName ||
      !email ||
      !password ||
      !ConfirmPassword ||
      !phonenumber
    ) {
      dispatch(
        showAlert({
          title: "signup",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false
    ) {
      dispatch(
        showAlert({
          title: "Invalid Email!",
          message:
            "Please enter a valid email address in the correct format (e.g., example@example.com)",
        })
      );
      return;
    } else if (
      /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/.test(
        password
      ) == false
    ) {
      dispatch(
        showAlert({
          title: "Invalid Passwords",
          message:
            "Ensure password is of length 8, at least one uppercase and lowercase, at least one special case letter(@#!) and one number!",
        })
      );
      return;
    } else if (password !== ConfirmPassword) {
      dispatch(
        showAlert({
          title: "Password!",
          message: "Password and confirm password must be match",
        })
      );
      return;
    } else if (userRole == "Vendor") {
      if (!SelectedVendorType || !services || !Experience) {
        dispatch(
          showAlert({
            title: "signup",
            message: "All fields are mandatory.",
            type: "Error",
            status: 400,
          })
        );
        return;
      } else if (
        SelectedVendorType == "Company" ||
        SelectedVendorType == "Venue"
      ) {
        if (!CompanyName || !CompanyImage) {
          dispatch(
            showAlert({
              title: "signup",
              message: "Please provide your company detail!",
              type: "Error",
              status: 400,
            })
          );
          return;
        }
      }
    }
    let userData = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      contact_no: phonenumber,
      password: password,
      confirm_password: ConfirmPassword,
      role: userRole?.toLowerCase(),
      dob: DOB ? moment(DOB).format("YYYY-MM-DD") : null,
      gender: null,
      vendor_type: SelectedVendorType?.toLowerCase(),
      company_name: CompanyName,
      experience: Experience,
      service_id: services?.id,
      company_image: CompanyImage,
    };
    dispatch(AuthMiddleware.signUp(userData))
      .then(() => {
        navigation("/");
      })
      .catch();
  };

  //=====================social logins=============================
  const googleLogin = useGoogleLogin({
    onSuccess: async (respose) => {
      try {
        const res = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${respose.access_token}`,
            },
          }
        );
        if (res) {
          // console.log("sdfsdfsdfsfdsdfsdf", res);
          dispatch(
            AuthMiddleware.Sociallogin({
              email: res?.data?.email,
              given_name: res?.data?.given_name,
              family_name: res?.data?.family_name,
              role: userRole,
            })
          );
        }
      } catch (err) {}
    },
    onError: (err) => {},
  });

  return (
    <div className={styles.mainCon}>
      <Row className={styles.subCon}>
        <Col className={styles.authImgCon}>
          <img src={authImg} className={styles.authImg} />
        </Col>
        <Col className={styles.authContent}>
          <Box boxClass={styles.box}>
            <TextComponent text={"Sign Up!"} textClass={styles.heading} />
            <TextComponent
              text={"Please Enter your Details to create an account"}
              textClass={styles.subHeading}
            />
            <div className={styles.inputs}>
              <Row className={styles.formRow}>
                <Col className={styles.formCol}>
                  <InputField
                    label="First Name"
                    placeholder={"Trish"}
                    value={firstName}
                    onChange={(e) => setfirstName(e.target.value)}
                  />
                </Col>
                <Col className={styles.formCol}>
                  <InputField
                    label="Last Name"
                    placeholder={"James"}
                    value={lastName}
                    onChange={(e) => setlastName(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className={styles.formRow}>
                <Col className={styles.formCol}>
                  <PhoneInput
                    className={styles.phoneInput}
                    value={phonenumber}
                    onChange={setphonenumber}
                    label={"Phone"}
                  />
                </Col>
                <Col className={styles.formCol}>
                  <InputField
                    label="Email Address"
                    placeholder={"email@bestdayever.com"}
                    value={email}
                    onChange={(e) => setemail(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className={styles.formRow}>
                <Col className={styles.formCol}>
                  <InputField
                    label={"Password"}
                    placeholder={"••••••••••••••••"}
                    type={passwordVisible ? "password" : "text"}
                    value={password}
                    onChange={(e) => setpassword(e.target.value)}
                    rightIcon={
                      !passwordVisible ? (
                        <BsEyeFill color="var(--light-grey)" size={15} />
                      ) : (
                        <BsEyeSlashFill color="var(--light-grey)" size={15} />
                      )
                    }
                    onRightIconPress={() =>
                      setpasswordVisible(!passwordVisible)
                    }
                    security={passwordVisible}
                  />
                </Col>
                <Col className={styles.formCol}>
                  <InputField
                    label={"Confirm Password"}
                    placeholder={"••••••••••••••••"}
                    type={confPasswordVisible ? "password" : "text"}
                    value={ConfirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    rightIcon={
                      !confPasswordVisible ? (
                        <BsEyeFill color="var(--light-grey)" size={15} />
                      ) : (
                        <BsEyeSlashFill color="var(--light-grey)" size={15} />
                      )
                    }
                    onRightIconPress={() =>
                      setconfPasswordVisible(!confPasswordVisible)
                    }
                    security={confPasswordVisible}
                  />
                </Col>
              </Row>
              <Row className={styles.formRow}>
                <Col className={styles.formCol}>
                  <div className={styles.userType}>
                    <text className={styles.label}>User Type</text>
                    <div className={styles.userTypeDiv}>{state?.role}</div>
                  </div>
                </Col>
                {state.role == "Vendor" ? (
                  <Col className={styles.formCol}>
                    <DropDown
                      placeholder={"Vendor Type"}
                      name={"role"}
                      label={"Vendor Type"}
                      onChange={handleChangeVendorType}
                      options={[
                        { value: "Individual", option: "Individual" },
                        { value: "Company", option: "Company" },
                        { value: "Venue", option: "Venue" },
                      ]}
                    />
                  </Col>
                ) : null}
              </Row>
              {state.role == "Vendor" ? (
                <Row className={styles.formRow}>
                  <Col className={styles.formCol}>
                    <DropDown
                      placeholder={"Select Service"}
                      name={"role"}
                      label={"Service"}
                      onChange={handleChangeService}
                      object={Service}
                    />
                  </Col>
                  <Col className={styles.formCol}>
                    <InputField
                      label="Experience"
                      placeholder={"2 years"}
                      value={Experience}
                      type="number"
                      onChange={(e) => setExperience(e.target.value)}
                    />
                  </Col>
                </Row>
              ) : null}
              {SelectedVendorType == "Company" ||
              SelectedVendorType == "Venue" ? (
                <Row className={styles.formRow}>
                  <Col className={styles.formCol}>
                    <InputField
                      label="Company Name"
                      placeholder={"Company Name"}
                      value={CompanyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                    />
                  </Col>
                  <Col className={styles.formCol}>
                    <div onClick={handleClick} className={styles.imgDiv}>
                      {/* <img src={companyImg} /> */}
                      <img
                        src={
                          CompanyImage
                            ? URL.createObjectURL(CompanyImage)
                            : companyImg
                        }
                      />
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => setCompanyImage(e.target.files[0])}
                      ref={hiddenFileInput}
                      style={{ display: "none" }}
                    />
                  </Col>
                </Row>
              ) : null}
            </div>
            <SubmitButton title={"Sign Up"} onClick={() => onSignUp()} />
            <div className={styles.forgotDiv}>
              <TextComponent
                text={"Or SignUp with"}
                textClass={styles.loginText}
              />
              <div className={styles.social}>
                <img
                  src={google}
                  className={styles.socialImg}
                  onClick={googleLogin}
                />
                {/* <img src={facebook} className={styles.socialImg} /> */}
              </div>
              <div className={styles.accDiv}>
                <TextComponent
                  text={"Already have an account?"}
                  textClass={styles.accText}
                />
                <TextComponent
                  text={"LogIn"}
                  textClass={styles.signText}
                  onClick={() => navigation("/")}
                />
              </div>
            </div>
          </Box>
        </Col>
        {/* <Col className={styles.rightCol} >
          <div className={styles.loginFormCont}>
            <div style={{ width: '100%' }}>
            
                <InputField label='Email' placeholder={'email@bestdayever.com'} />
                <InputField
                    label={'Password'}
                    placeholder={'*************'}
                    value={password}
                    onChange={(e) => setpassword(e)}
                    rightIcon={passwordVisible ? <BsEyeFill color='var(--light-grey)' size={15}/> : <BsEyeSlashFill color='var(--light-grey)' size={15}/>}
                    onRightIconPress={() => setpasswordVisible(!passwordVisible)}
                    security={passwordVisible} />
                    <SubmitButton title={'Log in'}/>
            </div>
          </div>
          
        </Col> */}
      </Row>
    </div>
  );
};

export default Signup;
